/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_Drop_HintInputs */

const en_us2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straight after the one before, lighter and with no rest. Counts as work.`)
};

const pt_br2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo depois da anterior, com menos carga e sem descanso. Conta como trabalho.`)
};

const es_419_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justo después de la anterior, con menos peso y sin descanso. Cuenta como trabajo.`)
};

const pt_pt2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo a seguir à anterior, com menos carga e sem descanso. Conta como trabalho.`)
};

const fr_fr2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste après la précédente, plus légère et sans repos. Compte comme travail.`)
};

const de_de2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkt nach dem vorherigen, leichter und ohne Pause. Zählt als Arbeitssatz.`)
};

const it_it2_workout_logging_kind_drop_hint = /** @type {(inputs: Workout_Logging_Kind_Drop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subito dopo la precedente, più leggera e senza recupero. Conta come lavoro.`)
};

/**
* | output |
* | --- |
* | "Straight after the one before, lighter and with no rest. Counts as work." |
*
* @param {Workout_Logging_Kind_Drop_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_drop_hint = /** @type {((inputs?: Workout_Logging_Kind_Drop_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_Drop_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_drop_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_drop_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_drop_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_drop_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_drop_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_drop_hint(inputs)
	return en_us2_workout_logging_kind_drop_hint(inputs)
});
export { workout_logging_kind_drop_hint as "workout-logging.kind_drop_hint" }